import Voucher from '../records/customer/Voucher';
import { NotFoundError } from '../lib/APIClient';
import { resolveAll } from '../helpers/LinkMapper';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';


const VoucherService = {

    async getAll (user) {
        try {
            const userId = user.id;
            const endpoint = `/customers/${userId}/vouchers`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            return resolveAll(response.result).as(Voucher);
        } catch (error) {
            if (!(error instanceof NotFoundError)) { throw error; }
            return null;
        }
    }

};


export default VoucherService;
